import { country } from '../configuration';
import { allowedLicensePlateSymbols, LicensePlateNumberMask } from '../regexp';
import { CarCharacteristics } from './car-characteristics';
import { CarOwnerShip } from './car-ownership';
import { CarPart } from './car-part';
export interface Car {
  registrationCode?: string;
  licensePlateNumber?: string;
  countryCode?: country;
  manufacturer?: string;
  model?: string;
  version?: string;
  firstRegistration?: Date;
  parts?: CarPart[];
  ownerShip?: CarOwnerShip;
  characteristics?: CarCharacteristics;
  vehicleType?: VehicleTypeName;
  vinNumber?: string;
}

export interface VehicleType {
  name: VehicleTypeName;
  icon: string;
}
export type VehicleTypeName = `${VehicleTypeNameEnum}`;

export enum VehicleTypeNameEnum {
  car = 'car',
  truck = 'truck',
  tractor = 'tractor',
  bus = 'bus',
  van = 'van',
  publicworksvehicle = 'publicworksvehicle',
  smallcar = 'smallcar',
  utility = 'utility',
  other = 'other',
}

export const generateNewCar = (
  car: Partial<Car>,
  countryPatterns: country[],
  defaultCountryPattern: country
) => {
  return {
    licensePlateNumber: !!car.licensePlateNumber
      ? LicensePlateNumberMask.mask(car.licensePlateNumber, countryPatterns)
      : null,
    countryCode: defaultCountryPattern,
    manufacturer: car.manufacturer ?? null,
    version: car.version ?? null,
    model: car.model ?? null,
    registrationCode: car.manufacturer ?? null,
    firstRegistration: car.firstRegistration ?? null,
    parts: car.parts ?? null,
    ownerShip: car.ownerShip ?? {
      type: null,
      name: null,
    },
    characteristics: car.characteristics ?? {
      registration: null,
      registrationType: null,
      color: null,
      energy: null,
      cylinders: null,
      numberOfDoors: null,
      propulsionType: null,
      chassisNumber: null,
      modelYear: null,
      engineNumber: null,
      gearboxType: null,
      gearboxNbSpeed: null,
      gearboxNumber: null,
      unloadedWeight: null,
      horsepower: null,
      fiscalPower: null,
      kwPower: null,
      totalRollingWeight: null,
      co2Emission: null,
    },
    vehicleType: car.vehicleType ?? null,
  };
};

export const isSameLicensePlate = (firstLicensePlate, secondLicensePlate) => {
  return (
    firstLicensePlate
      ?.replace(new RegExp(`[^${allowedLicensePlateSymbols}]`, 'g'), '')
      .toUpperCase() ===
    secondLicensePlate
      ?.replace(new RegExp(`[^${allowedLicensePlateSymbols}]`, 'g'), '')
      .toUpperCase()
  );
};
